<template>
  <v-row no-gutters>
    <v-col cols="12" md="8" order="12" order-sm="1">
      <v-data-table
        v-if="orders.length"
        :custom-sort="customSort"
        :headers="headers"
        :items="orders"
        :items-per-page="pagination.perPage"
        :page.sync="pagination.page"
        :expanded="expanded"
        item-key="system"
        @click:row="select"
        hide-default-footer
        dense
        :class="{
          'd-none d-md-block': true,
          'v-data-table--clickable': this.Scope.name === 'Thales',
        }"
      >
        <template v-slot:item.shipment="{ item }">
          <span class="d-block">
            {{ _.get(item, 'shipment') }}
          </span>
        </template>
        <template v-slot:item.system="{ item }">
          <span
            v-if="!scope.includes('SCO_THALES')"
            class="d-block">
            {{ _.get(item, 'system') }}
          </span>
          <span
            v-else
            class="d-block">
            {{ _.get(item, 'customer') }}
          </span>
        </template>
        <template v-slot:item.dateSetDep="{ item }">
          <span class="d-block">
            {{ _.get(item, 'dates.plannedStart') | datetime }}
          </span>
          <span class="d-block primary--text">
            {{ _.get(item, 'dates.actualStart') | datetime }}
          </span>
        </template>
        <template v-slot:item.dateSetArr="{ item }">
          <span class="d-block">
            {{ _.get(item, 'dates.plannedEnd') | datetime }}
          </span>
          <span class="d-block primary--text">
            {{ _.get(item, 'dates.actualEnd') | datetime }}
          </span>
        </template>
        <template v-slot:item.from="{ item }">
          <span class="d-block font-weight-bold">
            {{ _.get(item, 'from.country') }}
          </span>
          <span class="d-block caption">{{ _.get(item, 'from.city') }}</span>
        </template>
        <template v-slot:item.to="{ item }">
          <span class="d-block font-weight-bold">
            {{ _.get(item, 'to.country') }}
          </span>
          <span class="d-block caption">{{ _.get(item, 'to.city') }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn icon @click.stop :to="routeTo(item, 'details')">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="py-4">
            <v-btn
              :to="routeTo(item, 'details')"
              v-translate="'search.buttons.details'"
              color="primary"
              class="mr-3"
              small
            >Details</v-btn>
            <v-btn
              :to="routeTo(item, 'events')"
              v-translate="'search.buttons.events'"
              color="primary"
              class="mr-3"
              small
            >Events</v-btn>
            <v-btn
              :to="routeTo(item, 'contents')"
              v-translate="'search.buttons.contents'"
              color="primary"
              class="mr-3"
              small
            >Contents</v-btn>
          </td>
        </template>
      </v-data-table>

      <v-col cols="12" class="d-block d-md-none" order="12" order-sm="1">
        <v-expansion-panels focusable v-if="orders.length">
          <v-expansion-panel
            v-model="expandStatus"
            v-for="(order, index) in orders"
            :key="index"
          >
          <div v-if="verifyExpansionPanel(index)">
            <v-expansion-panel-header @click="select(order)">
              <v-row class="justify-center d-flex text-center">
                <v-col class="pb-0 pt-0">
                  <h4>Delivery</h4>
                </v-col>
                <v-col class="pb-0">
                  {{ order.system }}
                </v-col>
              </v-row>
              <v-row class="justify-center d-flex text-center">
                <v-col class="pb-0 pt-0">
                  <h4>Geodis</h4>
                </v-col>
                <v-col class="pb-0">
                  {{ order.shipment }}
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="pt-2 align-center">
                <h5>Est. Dep. / Act. Dep.</h5>
                <v-spacer></v-spacer>
                <p class="text-end">
                  <b>{{ _.get(order, 'dates.plannedStart') | datetime}}</b><br>
                  {{_.get(order, 'dates.actualStart') | datetime}}
                </p>
              </v-row>
              <v-row class="align-center">
                <h5>Est. Arr. / Act. Arr.</h5>
                <v-spacer></v-spacer>
                <p class="text-end">
                  <b>{{ _.get(order, 'dates.plannedEnd') | datetime}}</b><br>
                  {{_.get(order, 'dates.actualEnd') | datetime}}
                </p>
              </v-row>
              <v-row class="align-center">
                <h5>Origin</h5>
                <v-spacer></v-spacer>
                <p class="text-end">
                  <b>{{ _.get(order, 'from.country') }}</b><br>{{_.get(order, 'from.city')}}
                </p>
              </v-row>
              <v-row class="align-center">
                <h5>Destination</h5>
                <v-spacer></v-spacer>
                <p class="text-end">
                  <b>{{ _.get(order, 'to.country') }}</b><br>{{_.get(order, 'to.city')}}
                </p>
              </v-row>
              <v-row class="align-center">
                <h5>Details</h5>
                <v-spacer></v-spacer>
                <v-btn icon @click.stop :to="routeTo(order, 'details')">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-row>
            </v-expansion-panel-content>
          </div>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-pagination
        v-if="orders.length"
        v-model="pagination.page"
        :length="Math.ceil(orders.length / pagination.perPage)"
        :total-visible="5"
        class="my-5"
        color="primary"
      ></v-pagination>
    </v-col>
    <v-col cols="12" md="4" order="1" order-sm="12" class="pt-3 pt-sm-0">
      <div class="map__holder mb-5">
        <app-map :site-a="sites.A" :site-b="sites.B" :update="sites.uid"/>
      </div>
      <div class="search__details text-center text-sm-left" v-if="!_.isEmpty(order)">
        <div class="search__details__from body-2 mb-5">
          <span>
            <v-icon size="20">mdi-upload</v-icon>
            {{ 'search.origin' | translate }}:
          </span>
          <p class="mb-0 text-center text-sm-left font-weight-bold">
            {{ _.get(order, 'from.name') }}
          </p>
          <p class="mb-0 text-center text-sm-left caption grey--text">
          {{ _.get(order, 'from.address') }}
          </p>
          <p class="mb-0 text-center text-sm-left">
            {{ _.get(order, 'from.city') }}
          </p>
          <p class="mb-0 text-center text-sm-left">
            {{ _.get(order, 'from.country') }}
          </p>
        </div>
        <div class="search__details__to body-2 mb-5">
          <span><v-icon size="20">mdi-download</v-icon> Destination:</span>
          <p class="mb-0 text-center text-sm-left font-weight-bold">
            {{ _.get(order, 'to.name') }}
          </p>
          <p class="mb-0 text-center text-sm-left caption grey--text">
            {{ _.get(order, 'to.address') }}
          </p>
          <p class="mb-0 text-center text-sm-left">
            {{ _.get(order, 'to.city') }}
          </p>
          <p class="mb-0 text-center text-sm-left">
            {{ _.get(order, 'to.country') }}
          </p>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import { keys } from 'lodash';
import { oftype } from '@/utils';
import locationMixin from '@/mixins/location.mixin';

export default {
  name: 'name-business-scope-search',
  mixins: [locationMixin],
  data() {
    return {
      searched: false,
      searching: false,
      order: {},
      field: '',
      scope: '',
      expanded: [],
      pagination: {
        page: 1,
        perPage: 10,
      },
    };
  },
  computed: {
    ...mapState({
      results: 'Search',
      Scope: 'Scope',
    }),
    mode() {
      return this.$route.name.includes('client') ? 'client' : 'track';
    },
    orders() {
      const { results } = this;
      if (results) return oftype(results, 'Array') ? results : [results];
      return [];
    },
    expandStatus: {
      get() {
        return this.orders.slice((this.pagination.page - 1) * 5,
          this.pagination.page * 5).map(i => i.expand);
      },
      set($status) {
        const index = $status.findIndex((s, i) => s !== this.expandStatus[i])
          + (this.pagination.page - 1) * 5;
        // console.log('expand', index);
        this.orders[index].expand = $status[index];
      },
    },
    headers() {
      const array = [
        {
          text: 'Est. Dep. / Act. Dep.',
          sortable: true,
          value: 'dateSetDep',
        },
        {
          text: 'Est. Arr. / Act. Arr.',
          sortable: true,
          value: 'dateSetArr',
        },
        {
          text: this.$lang.translate('search.origin'),
          sortable: true,
          value: 'from',
        },
        {
          text: 'Destination',
          sortable: true,
          value: 'to',
        },
        {
          text: this.$lang.translate('search.details'),
          sortable: true,
          value: 'action',
        },
      ];

      switch (this.Scope.system) {
        case 'Zenith': {
          array.unshift(
            {
              text: 'Geodis',
              sortable: true,
              value: 'system',
            },
            {
              text: 'Delivery',
              sortable: true,
              value: 'shipment',
            },
          );

          break;
        }
        case 'Mpo': {
          array.unshift(
            {
              text: this.Scope.name.includes('Thales')
                ? this.$lang.translate('search.headers.geodisID')
                : 'Geodis',
              sortable: true,
              value: 'shipment',
            },
            {
              text: this.Scope.name.includes('Thales')
                ? this.$lang.translate('search.headers.deliveryOrder')
                : 'Delivery',
              sortable: true,
              value: 'system',
            },
          );
          break;
        }
        default: {
          console.log('No system found');
        }
      }
      return array;
    },
  },
  methods: {
    routeTo(item, section) {
      switch (this.mode) {
        case 'client': {
          return {
            name: `client.business-scope.${section}`,
            params: this.$route.params,
            query: {
              field: this.Scope.name === 'IBM' ? 'serviceNumber' : this.track,
              number: window._.get(item, 'system'),
              org: this.scope,
            },
          };
        }
        default: {
          return {
            name: `track.business-scope.${section}`,
            params: { number: window._.get(item, 'system') },
            query: { [this.field]: window._.get(item, 'shipment'), org: this.scope },
          };
        }
      }
    },
    customSort: (items, index, isDesc) => {
      items.sort((a, b) => {
          if (index[0] === 'shipment') {
            const shipmentA = !a.shipment
            ? 'z'
            : a.shipment.toLowerCase();
            const shipmentB = !b.shipment
            ? 'z'
            : b.shipment.toLowerCase();

            if (!isDesc[0]) {
              return shipmentA.localeCompare(shipmentB);
            }
            return shipmentB.localeCompare(shipmentA);
          }
          if (index[0] === 'system') {
            const systemA = !a.customer
            ? 'z'
            : a.customer.toLowerCase();
            const systemB = !b.customer
            ? 'z'
            : b.customer.toLowerCase();

            if (!isDesc[0]) {
              return systemA.localeCompare(systemB);
            }
            return systemB.localeCompare(systemA);
          }
          if (index[0] === 'to') {
            const cityA = !a.to.city
            ? 'z'
            : a.to.city.toLowerCase();
            const cityB = !b.to.city
            ? 'z'
            : b.to.city.toLowerCase();

            if (!isDesc[0]) {
              return cityA.localeCompare(cityB);
            }
            return cityB.localeCompare(cityA);
          }
          if (index[0] === 'from') {
            const cityA = !a.from.city
            ? 'z'
            : a.from.city.toLowerCase();
            const cityB = !b.from.city
            ? 'z'
            : b.from.city.toLowerCase();

            if (!isDesc[0]) {
              return cityA.localeCompare(cityB);
            }
            return cityB.localeCompare(cityA);
          }
          if (index[0] === 'dateSetArr') {
            const dateA = !a.dates.actualEnd
            ? null
            : a.dates.actualEnd;
            const dateB = !b.dates.actualEnd
            ? null
            : b.dates.actualEnd;

            // if (!dateA) {
            //   dateA = !a.dates.plannedEnd
            //   ? null
            //   : a.dates.plannedEnd;
            // }
            // if (!dateB) {
            //   dateB = !a.dates.plannedEnd
            //   ? null
            //   : a.dates.plannedEnd;
            // }

            if (!isDesc[0]) {
              return new Date(dateB) - new Date(dateA);
            }
            return new Date(dateA) - new Date(dateB);
          }
          if (index[0] === 'dateSetDep') {
            const dateA = !a.dates.actualStart
            ? null
            : a.dates.actualStart;
            const dateB = !b.dates.actualStart
            ? null
            : b.dates.actualStart;

            if (!isDesc[0]) {
              return new Date(dateB) - new Date(dateA);
            }
            return new Date(dateA) - new Date(dateB);
          }
          return false;
      });
      return items;
    },
    select(order) {
      this.order = order;

      // Expandable rows only for Thales.
      if (this.Scope.name === 'Thales') {
        this.expanded = this.expanded[0] === order ? [] : [order];
      }
    },
    verifyExpansionPanel(index) {
      if (index >= (this.pagination.page - 1) * this.pagination.perPage
        && index < this.pagination.page * this.pagination.perPage) {
        return true;
      }
      return false;
    },
  },
  created() {
    const field = keys(this.$route.query).find(q => q !== 'org');
    this.scope = this.$route.query.org;
    this.track = this.$route.query[field] || '';
    this.field = field || '';
  },
};
</script>
